import { ActionType } from 'typesafe-actions';
import BaseReducer, {
baseInitialState,
} from '../../../../../boilerplate/redux/BaseReducer';
import { IBaseStateType } from '../../../../../boilerplate/redux/types/IBaseStateType';
import { IBrandType } from '../../types/IBrandType';
import * as brandGroupedActions from './brandGroupedActions';

export type BrandGroupedAction = ActionType<typeof brandGroupedActions>;

export interface IBrandGroupedStateType extends IBaseStateType {
	readonly entryMap: { [queryKey: string]: IBrandType };
	readonly queries: { [queryKey: string]: IBrandType[] };
}

export function brandGroupedReducer(
	state = baseInitialState as IBrandGroupedStateType,
	action: BrandGroupedAction,
) {
	const Reducer = new BaseReducer('brandGroupedReducer', 'slug');

	return Reducer.extend(state, action, (innerState, innerAction) => {
		switch (innerAction.type) {
			case 'OTHER_ACTION_TYPE':
				return Object.assign({}, innerState, {
					data: null,
					done: false,
					error: null,
					loading: true,
				});

			default:
				return innerState;
		}
	});
}
